/** @file Extracts the structured Pose2DError from a thrown value, or null for an ordinary error. */
import { ERROR_CODES } from './errorCodes';
import type { Pose2DError } from './pose2dError';

/** The `.pose2d` value attached by throwError, or null when `e` is not one of ours. Never throws. */
export function toPose2DError(e: unknown): Pose2DError | null {
  try {
    if (typeof e !== 'object' || e === null || !('pose2d' in e)) return null;
    const value: unknown = e.pose2d;
    if (typeof value !== 'object' || value === null) return null;
    const { code, message } = value as { code?: unknown; message?: unknown };
    return typeof code === 'string' && Object.hasOwn(ERROR_CODES, code) && typeof message === 'string' ? (value as Pose2DError) : null;
  } catch {
    return null;
  }
}
